import { __generator } from "tslib";
import { put, select, call } from 'redux-saga/effects';
import { request } from '../../xhr';
import { normalize } from '../../redux/normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { withOffset } from '../../Stream';
import { getCurrentStreamId, getCurrentMediaSource, getCurrentFolderId, getCurrentSubfolderId, } from '../selectors';
import { getGallectionTypeFromMediaSourceType } from '../helpers';
import updateGallectionSize from './updateGallectionSize';
function addDeviationsHandler(action) {
    var deviations, _a, streamId, mediaSource, currentFolderId, currentSubfolderId, _b, ids, entities;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                deviations = action.payload;
                return [4 /*yield*/, select(function (state) { return ({
                        streamId: getCurrentStreamId(state),
                        mediaSource: getCurrentMediaSource(state),
                        currentFolderId: getCurrentFolderId(state),
                        currentSubfolderId: getCurrentSubfolderId(state),
                    }); })];
            case 1:
                _a = _c.sent(), streamId = _a.streamId, mediaSource = _a.mediaSource, currentFolderId = _a.currentFolderId, currentSubfolderId = _a.currentSubfolderId;
                if (!streamId) {
                    return [2 /*return*/];
                }
                _b = normalize(deviations, [deviationSchema]), ids = _b.result, entities = _b.entities;
                return [4 /*yield*/, put(withOffset.actions.insertItems({
                        streamId: streamId,
                        items: ids,
                        entities: entities,
                        offset: 0,
                    }))];
            case 2:
                _c.sent();
                return [4 /*yield*/, call(updateGallectionSize, currentSubfolderId || currentFolderId, deviations.length)];
            case 3:
                _c.sent();
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/copy_deviations',
                        data: {
                            type: getGallectionTypeFromMediaSourceType(mediaSource),
                            deviationids: ids,
                            target_folderid: currentSubfolderId || currentFolderId,
                        },
                    })];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default addDeviationsHandler;
//# sourceMappingURL=addDeviations.js.map